import { DataTable } from "primereact/datatable";
import { TRequirement } from "./modal";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { JobTypeLabel, ReqTermLabel } from "../requirement-my-sales/modal";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TDropdown } from "../../shared/modal";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useToast } from "../../context/toastProvider";
import { baseUrl, Fetch } from "../../utilities/fetch";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInputCheck } from "../../shared/JVInputCheck";
import { JVInput } from "../../shared/JVInput";
import { JVInputMask } from "../../shared/JVInputMask";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { JVDate } from "../../shared/JVDate";
import { format } from "date-fns";
import { getToken } from "../../store/authStore";

interface Iprops {
  req?: TRequirement,
  open: boolean,
  hideDialog: () => void,
}

export enum SubmissionType {
  C2C = 1,
  Contract = 2,
  Permanent = 3
}
export enum VisaReceivedBy {
  Candidate = 1,
  SubVendor = 2,
}
export enum TaxTerm {
  Tax_1099_All_Inclusive = 1,
  Tax_1099_With_Benefits = 2,
  C2C_All_Inclusive = 3,
  C2C_With_Benefits = 4,
  C2C_Without_Benefits = 5,
  Permanent = 6,
  W2_All_Inclusive = 7,
  W2_With_Benefits = 8
}
export enum PaymentTerm {
  Net_Seven = 1,
  Net_Fifteen = 2,
  Net_Thirty = 3,
  Net_Forty_Five = 4,
  Net_Sixty = 5,
  Pay_On_Pay = 6,
}
export const Submission_Type = [
  { id: SubmissionType.Contract, name: "Contract" },
  { id: SubmissionType.Permanent, name: "Permanent" },
  { id: SubmissionType.C2C, name: "C2C" }
]
export const Payment_Term = [
  { name: "-- SELECT --", id: null },
  { name: "Net 30", id: PaymentTerm.Net_Thirty },
  { name: "Net 45", id: PaymentTerm.Net_Forty_Five },
  { name: "Pay on Pay", id: PaymentTerm.Pay_On_Pay },
  { name: "Net 15", id: PaymentTerm.Net_Fifteen },
  { name: "Net 60", id: PaymentTerm.Net_Sixty },
  { name: "Net 7", id: PaymentTerm.Net_Seven }
];
const Visa_Received_By = [
  { name: "--SELECT--", value: null },
  { name: "Candidate", value: VisaReceivedBy.Candidate },
  { name: "Subvendor", value: VisaReceivedBy.SubVendor }
];
export const Experience = [
  { name: 1 },
  { name: 2 },
  { name: 3 },
  { name: 4 },
  { name: 5 },
  { name: 6 },
  { name: 7 },
  { name: 8 },
  { name: 9 },
  { name: 10 },
  { name: 11 },
  { name: 12 },
  { name: 13 },
  { name: 14 },
  { name: 15 },
  { name: 16 },
  { name: 17 },
  { name: 18 },
  { name: 19 },
  { name: 20 }
]
export const NoticePeriod = [
  { value: 0, name: "Immediate" },
  { value: 7, name: "One Week" },
  { value: 15, name: "Two Week" },
  { value: 30, name: "One Month" },
  { value: 60, name: "Two Month" },
  { value: 90, name: "Three Month" }
]
export const NoticePeriodLabel = {
  0: "Immediate",
  7: "One Week",
  15: "Two Week",
  30: "One Month",
  60: "Two Month",
  90: "Three Month"
};
export const Tax_Term = [
  { id: TaxTerm.C2C_With_Benefits, name: "C2C with Benefits" },
  { id: TaxTerm.C2C_All_Inclusive, name: "C2C All Inclusive" },
  { id: TaxTerm.Tax_1099_All_Inclusive, name: "1099 All Inclusive" },
  { id: TaxTerm.Tax_1099_With_Benefits, name: "1099 with Benefits" },
  { id: TaxTerm.W2_All_Inclusive, name: "W2 All Inclusive" },
  { id: TaxTerm.W2_With_Benefits, name: "W2 with Benefits" },
  { id: TaxTerm.Permanent, name: "Permanent" }
]
export const TaxTermLabel = {
  [TaxTerm.C2C_With_Benefits]: "C2C with Benefits",
  [TaxTerm.C2C_All_Inclusive]: "C2C All Inclusive",
  [TaxTerm.Tax_1099_All_Inclusive]: "1099 All Inclusive",
  [TaxTerm.Tax_1099_With_Benefits]: "1099 with Benefits",
  [TaxTerm.W2_All_Inclusive]: "W2 All Inclusive",
  [TaxTerm.W2_With_Benefits]: "W2 with Benefits",
  [TaxTerm.Permanent]: "Permanent"
};
export const SubmissionTypeLabel = {
  [SubmissionType.C2C]: "C2C",
  [SubmissionType.Contract]: "Contract",
  [SubmissionType.Permanent]: "Permanent"
};

export interface ISubmissionForm {
  identityType?: "Email ID" | "Cons. ID";
  identity?: string;

  id?: number; //cm
  name?: string; //cm
  email?: string; //cm
  homeNo?: string; //cm
  jobTitle?: string; //cm
  visaId?: number; //cm
  countryId?: number; //cm
  stateId?: number; //cm
  cityId?: number; //cm
  experienceInMonth?: number; //cm
  linkedin?: string; //cm
  noticePeriodInDays?: number; //cm
  hourlyRate?: number; //cm
  annualSalary?: number; //cm
  dob?: string; //cm
  ssn?: string; //cm

  degree?: string; //ce
  passoutYear?: string; //ce
  university?: string; //ce

  tax_Term?: TaxTerm; //csl
  payment_Term?: PaymentTerm | null; //cls
  faceToFaceInterview?: boolean; //csl
  addition_Info?: string; //csl
  submissionType?: SubmissionType; //csl
  buying_Rate?: number; //csl
  submittal_Rate?: number; //csl
  visaReceivedBy?: VisaReceivedBy | null; //csl

  contactPersonEmail?: string; //scp
  vendorCompanyId?: number; //scp
  contactPersonName?: string; //scp
  contactPersonPhoneNo?: string; //scp

  state?: TDropdown;
  city?: TDropdown;
  vendorCompany?: TDropdown;
}


export const EmptySubmission: ISubmissionForm = {
  identityType: "Email ID",

  id: undefined,
  name: '',
  email: '',
  homeNo: undefined,
  jobTitle: '',
  visaId: undefined,
  visaReceivedBy: null,
  countryId: undefined,
  stateId: undefined,
  cityId: undefined,
  experienceInMonth: undefined,
  noticePeriodInDays: undefined,
  faceToFaceInterview: false,
  hourlyRate: undefined,
  tax_Term: TaxTerm.C2C_All_Inclusive,
  payment_Term: null,
  dob: '',
  degree: '',
  contactPersonEmail: '',
  ssn: '',
  vendorCompanyId: undefined,
  submissionType: undefined,
  university: '',
  contactPersonName: '',
  annualSalary: undefined,
  passoutYear: undefined,
  contactPersonPhoneNo: undefined,
  linkedin: '',

  state: { id: 0, name: '' },
  city: { id: 0, name: '' },
  vendorCompany: { id: 0, name: '' },
}

const emailSchema = yup.object().shape({
  email: yup.string().required().email(),
});
const idSchema = yup.object().shape({
  id: yup.number().required().min(1),
});

const schema = yup.object({
  name: yup.string().required(),
  email: yup.string().required().email(),
  homeNo: yup.string().required(),
  jobTitle: yup.string().required(),
  visaId: yup.number().min(1).required(),
  visaReceivedBy: yup.object().when("visaId", (val) => {
    return val === 4
      ? yup.number().nullable()
      : yup.number().min(1, "Visa Received By is required").required("Visa Received By is required").typeError("Visa Received By is required");
  }),
  state: yup.object().shape({
    id: yup.number().min(1, "State is required*").required("State is required*"),
    name: yup.string().required(),
  }),
  city: yup.object().shape({
    id: yup.number().min(1, "City is required*").required("City is required*"),
    name: yup.string().required(),
  }),
  experienceInMonth: yup.number().min(1).required(),
  noticePeriodInDays: yup.number().required(),
  faceToFaceInterview: yup.boolean().required(),
  hourlyRate: yup.number().required(),
  tax_Term: yup.number().required().min(1, "Tax Term is required*"),
  payment_Term: yup.number().when("tax_Term", (val) => {
    return val === TaxTerm.Tax_1099_All_Inclusive || val === TaxTerm.Tax_1099_With_Benefits || val === TaxTerm.W2_All_Inclusive || val === TaxTerm.W2_With_Benefits ? yup.number().min(1).required("Payment Term is Required").nullable() : yup.number().nullable();
  }),
  contactPersonEmail: yup.string().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive ? yup.string().email().required() : yup.string();
  }),
  vendorCompany: yup.object().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive
      ? yup.object().shape({
        id: yup.number().min(1, "Employer Company is required*").required("Employer Company is required*"),
        name: yup.string().required(),
      })
      : yup.object().shape({
        id: yup.number(),
        name: yup.string(),
      });
  }),
  contactPersonName: yup.string().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive ? yup.string().required() : yup.string();
  }),
  contactPersonPhoneNo: yup.string().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive ? yup.string().required() : yup.string();
  }),

  degree: yup.string(),
  university: yup.string(),
  passoutYear: yup.string(),
  ssn: yup.string(),
  linkedin: yup.string().url().nullable(),
  submissionType: yup.number().optional().nullable(),
  annualSalary: yup.string(),
});

export const SubmissionForm = (props: Iprops) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState<Array<TDropdown>>();
  const [states, setStates] = useState<Array<TDropdown>>();
  const [cities, setCities] = useState<Array<TDropdown>>();
  const [visa, setVisa] = useState<Array<TDropdown>>();
  const [clientCompanies, setClientCompanies] = useState<Array<TDropdown>>();
  const [additionInfo, setAdditionInfo] = useState("");

  const [disableEmployeeDetails, setDisableEmployeeDetails] = useState(false);
  const [disablePaymentsTerm, setDisablePaymentsTerm] = useState(true);
  const [resumeFile, setResumeFile] = useState<File | null | any>(null);
  const [visaFile, setVisaFile] = useState<File | null | any>(null);
  const [disableConsultant, setDisableConsultant] = useState(true);

  const [candidateTodaySubmissions, setCandidateTodaySubmissions] = useState<{ data: any[], total: number, show: boolean }>({ data: [], total: 0, show: false });

  const { control, handleSubmit, watch, formState: { errors }, reset, setValue, } = useForm<ISubmissionForm>({
    resolver: yupResolver(schema),
    defaultValues: EmptySubmission,
    shouldFocusError: false,
  });

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "tax_Term") {
        if (value.tax_Term === TaxTerm.C2C_With_Benefits || value.tax_Term === TaxTerm.C2C_All_Inclusive) {
          setDisableEmployeeDetails(false);
        } else {
          setDisableEmployeeDetails(true);
        }
      }
      if (name === "tax_Term") {
        if (value.tax_Term === TaxTerm.Tax_1099_All_Inclusive || value.tax_Term === TaxTerm.Tax_1099_With_Benefits || value.tax_Term === TaxTerm.W2_All_Inclusive || value.tax_Term === TaxTerm.W2_With_Benefits) {
          setDisablePaymentsTerm(false);
        } else {
          setDisablePaymentsTerm(true);
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  const countryId = watch('countryId');
  const state = watch('state');

  const loadCountries = async () => {
    const data = await Fetch<TDropdown[]>(`dropdown/countries`);
    if (data) {
      setCountries(data);
    }
  }
  const loadVisa = async () => {
    const data = await Fetch<TDropdown[]>("dropdown/visa");
    if (data) {
      setVisa(data);
    }
  }

  const loadStates = async (filter: string | null) => {
    if (countryId) {
      const data = await Fetch<TDropdown[]>("dropdown/states",
        { query: `countryId=${countryId}&filter=${filter}` });
      if (data) {
        setStates(data);
      }
    } else {
      showToast({ severity: 'error', detail: "Select the Country First.", life: 3000 });
    }
  }
  const completeMethodState = (event: { query: string }) => {
    loadStates(event.query);
  }

  const loadCities = async (filter: string | null) => {
    if (state?.id) {
      const data = await Fetch<TDropdown[]>("dropdown/cities", {
        query: `stateId=${state.id}&filter=${filter}`
      });
      if (data) {
        setCities(data);
      }
    } else {
      showToast({ severity: 'error', detail: "Select the State First.", life: 3000 });
    }
  }
  const completeMethodCity = (event: { query: string }) => {
    loadCities(event.query);
  }

  const loadClientCompanies = async (filter: string | null) => {
    const data = await Fetch<TDropdown[]>("dropdown/subVendorCompanies", {
      query: `filter=${filter}`
    });
    if (data) {
      setClientCompanies(data);
    }
  }
  const completeMethodClientCompanies = (event: { query: string }) => {
    loadClientCompanies(event.query);
  }

  useEffect(() => {
    loadVisa();
    loadCountries();
  }, []);

  const fillSubVendor = async () => {
    setLoading(true);
    const email = control._formValues.contactPersonEmail;
    if (email === "") return;
    if (!(email?.includes("gmail") || email?.includes("outlook") || email?.includes("protonmail") || email?.includes("aol") || email?.includes("yahoo") || email?.includes("hotmail") || email?.includes("rediff"))) {
      const isValid = await emailSchema.isValid({ email: email });
      if (isValid) {
        const data = await Fetch(`Candidate/subvendor/${email}`);
        if (data) {
          setValue("contactPersonEmail", data.email);
          setValue("contactPersonName", data.name);
          setValue("contactPersonPhoneNo", data.phoneNo);
          setValue("vendorCompanyId", data.vendorCompanyId);
          setValue("vendorCompany", { id: data.vendorCompanyId, name: data.vendorCompanyName });
        } else {
          setValue("contactPersonName", "");
          setValue("contactPersonPhoneNo", undefined);
          setValue("vendorCompanyId", undefined);
          setValue("vendorCompany", { id: 0, name: "" });
          showToast({ severity: "info", detail: "No Employer Found resistered with this Email-ID" });
        }
      } else showToast({ severity: "error", detail: "Please Enter a Valid Employer Email-ID" });
    } else {
      setValue("contactPersonName", "");
      setValue("contactPersonPhoneNo", undefined);
      setValue("vendorCompanyId", undefined);
      setValue("vendorCompany", { id: 0, name: "" });
      showToast({ severity: "error", detail: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
    }
    setLoading(false);
  };

  const fillSub = async (identity: string, isID: boolean) => {
    if (!props.req) return;
    setLoading(true);
    let query = `reqId=${props.req.id}&`;
    if (isID) query += `candidateId=${identity}`;
    else query += `candidateEmail=${identity}`;

    const data = await Fetch("Candidate", { query: query });
    if (data) {
      const _data = { ...data, ...data?.candidateEmployer, ...data?.candidateEducation, dob: data.dob ? new Date(data.dob) : null };
      reset(_data);
      setDisableConsultant(true);
      setValue("identity", _data.email);
      setValue("state", { id: _data.stateId, name: _data.stateName });
      setValue("city", { id: _data.cityId, name: _data.cityName });
      setValue("vendorCompany", { id: _data.vendorCompanyId, name: _data.vendorCompanyName });
      setValue("faceToFaceInterview", false);
      setValue("tax_Term", TaxTerm.C2C_With_Benefits);
    } else {
      reset(EmptySubmission);
      setDisableConsultant(false);
      setValue("identity", identity);
      !isID && setValue("email", identity);
    }
    setLoading(false);
  };

  const fillSubmission = async () => {
    const identity = control._formValues.identity;
    const identityType = control._formValues.identityType;
    if (identityType === "Email ID") {
      const isValid = await emailSchema.isValid({ email: identity });
      if (isValid) fillSub(identity, false);
      else showToast({ severity: "error", detail: "Please Enter a Valid Email-ID" });
    } else if (identityType === "Cons. ID") {
      const isValid = await idSchema.isValid({ id: identity });
      if (isValid) fillSub(identity, true);
      else showToast({ severity: "error", detail: "Please Enter a Valid Consultant-ID" });
    }
  };

  const saveToDB = async (body: ISubmissionForm) => {
    if (!props.req) return;

    setLoading(true);
    const candidate_Data = {
      id: body.id,
      name: body.name,
      email: body.email?.trim().toLowerCase(),
      homeNo: body.homeNo,
      jobTitle: body.jobTitle,
      visaId: body.visaId,
      countryId: body.countryId,
      stateId: body.state?.id,
      cityId: body.city?.id,
      experienceInMonth: body.experienceInMonth,
      noticePeriodInDays: body.noticePeriodInDays,
      hourlyRate: body.hourlyRate,
      dob: body.dob ? format(new Date(body.dob), 'yyyy-MM-dd') : undefined,
      ssn: body.ssn,
      linkedin: body.linkedin,
      annualSalary: body.annualSalary ? body.annualSalary : undefined,
      university: body.university,
      degree: body.degree,
      passoutYear: body.passoutYear,
    };

    const candidate_Submittal_Logs = {
      requirement_ID: props.req.id,
      faceToFaceInterview: body.faceToFaceInterview,
      tax_Term: body.tax_Term,
      payment_Term: body.payment_Term,
      submissionType: body.submissionType,
      buying_Rate: body.hourlyRate,
      addition_Info: additionInfo,
    };

    const sub_Vendor_Contact_Person_Mast = {
      email: body.contactPersonEmail,
      name: body.contactPersonName,
      phoneNo: body.contactPersonPhoneNo,
      vendorCompanyId: body.vendorCompany?.id,
    };

    const formData = new FormData();
    formData.append("candidateData", JSON.stringify(candidate_Data));
    if (!disableEmployeeDetails) formData.append("subVendorContact", JSON.stringify(sub_Vendor_Contact_Person_Mast));
    formData.append("submissionData", JSON.stringify(candidate_Submittal_Logs));
    formData.append("resume", resumeFile);
    formData.append("visa", visaFile);
    const token = getToken();
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    };
    const response = await fetch(`${baseUrl}RecruiterMyRequirement/${props.req.id}/submission`, params);

    if (!response.ok) {
      const message = await response.text();
      showToast({ severity: "error", detail: message, life: 3000 });
      setLoading(false);
      return;
    }

    const data = await response.json();

    if (data.isRunningPo === true) {
      showToast({ severity: "success", detail: `Candidate was already in running PO,  and ${data.message}` });
    } else showToast({ severity: "success", detail: data.message });
    onHide();
    setResumeFile(null);
    setVisaFile(null);
    setLoading(false);
  };

  function onSubmit(data: ISubmissionForm) {
    const email = data.contactPersonEmail;

    if (!resumeFile) {
      showToast({ severity: "error", detail: "Please Upload the Consultant Resume First." });
    } else if (!visaFile && data.visaId !== 4) {
      showToast({ severity: "error", detail: "Please Upload the Consultant Visa First." });
    } else if (disableEmployeeDetails) {
      if (resumeFile) saveToDB(data);
      else showToast({ severity: "error", detail: "Please Upload the Consultant Resume First." });
    } else {
      if (!(email?.includes("gmail") || email?.includes("outlook") || email?.includes("protonmail") || email?.includes("aol") || email?.includes("yahoo") || email?.includes("hotmail") || email?.includes("rediff"))) {
        if (resumeFile) saveToDB(data);
        else showToast({ severity: "error", detail: "Please Upload the Consultant Resume First." });
      } else {
        setValue("contactPersonName", "");
        setValue("contactPersonPhoneNo", undefined);
        setValue("vendorCompanyId", undefined);
        setValue("vendorCompany", { id: 0, name: "" });
        showToast({ severity: "error", detail: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
      }
    }
  }

  const onHide = () => {
    props.hideDialog();
    reset(EmptySubmission);
    setDisablePaymentsTerm(true);
    setDisableConsultant(true);
    setAdditionInfo("");
    setResumeFile(null);
    setVisaFile(null);
    setLoading(false);
  };

  const dFooter = () => {
    return (
      <div className="col-12 md:col-12 flex gap-4 justify-content-end">
        <Button loading={loading} form="submissionForm" label="SAVE" type="submit" style={{ width: "100px" }} />
        <Button className="p-button-outlined surface-200" style={{ width: "100px" }} label="CLEAR"
          onClick={() => reset(EmptySubmission)} type="button" />
      </div>
    );
  };

  const resumeUpload = (event: FileUploadHandlerParam) => {
    const file = event.files[0];
    if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      if (file.size > 1024 * 1024 * 2) {
        showToast({ severity: "error", detail: "DOCX File should be less than 2 MB." });
        event.options.clear();
        setResumeFile(null);
      } else {
        setResumeFile(file);
        event.options.clear();
      }
    } else {
      showToast({ severity: "error", detail: "Please Choose A DOCX File." });
      event.options.clear();
      setResumeFile(null);
    }
  };

  const visaUploade = (event: FileUploadHandlerParam) => {
    const file = event.files[0];
    if (file.size > 1024 * 1024 * 2) {
      showToast({ severity: "error", detail: "File should be less than 2 MB." });
      event.options.clear();
      setVisaFile(null);
    } else {
      setVisaFile(file);
      event.options.clear();
    }
  };


  return (
    <Dialog visible={props.open} style={{ width: '80vw' }} header="Submit Candidate" footer={dFooter} modal className="p-fluid" onHide={onHide}>
      <DataTable size="small" value={props.req ? [props.req] : []} lazy dataKey="id" emptyMessage="No Requirement found.">
        <Column field="id" header="ReqId" />
        <Column field="jobTitle" header="Job Title" />
        <Column field="duration" header="Duration" body={(r: TRequirement) => `${r.duration} month(s)`} />
        <Column field="jobType" header="Job Type" body={(r: TRequirement) => JobTypeLabel[r.jobType]} />
        <Column field="term" header="Term" body={(r: TRequirement) => ReqTermLabel[r.term]} />
        <Column field="skillCategory" header="Skill Category" />
        <Column field="interviewProcess" header="Interview Process" />
        <Column field="vendorCompanyName" header="Client Company" />
        <Column field="contactPersonName" header="Contact Person" />
        <Column field="location" header="Location" body={(r: TRequirement) => r.cityId ? `${r.cityName}, ${r.stateName}, ${r.countryName}` : '--'} />
        <Column field="visa" header="Visa" body={(r: TRequirement) => <span>{r.visa?.map(v => v.name).join(', ')}</span>} />
        <Column field="postedBy" header="Posted By" />
        <Column field="postedOn" header="Posted On" body={(r: TRequirement) => format(new Date(r.postedOn + 'z'), "MM-dd-yyyy hh:mm a")} />
      </DataTable>

      <form id="submissionForm" onSubmit={handleSubmit(onSubmit)}>
        <div className="p-fluid formgrid grid mt-3">
          <JVDropdown column={3} control={control} name="identityType" options={[{ name: "Email ID" }, { name: "Cons. ID" }]} optionLabel="name" optionValue="name" placeholder="--Select--" />
          <JVInputCheck required func={fillSubmission} control={control} name="identity" />
          {candidateTodaySubmissions.total > 0 && (
            <div className="field col-12 md:col-1">
              <Button type="button"
                label={candidateTodaySubmissions.total.toString()}
                className="p-button-rounded p-button-info"
                onClick={() => {
                  if (candidateTodaySubmissions.total > 0) setCandidateTodaySubmissions(prev => ({ ...prev, show: true }));
                }} />
            </div>
          )}
        </div>

        <Accordion multiple activeIndex={[0, 1]}>
          <AccordionTab header="Consultant Required Details:">
            <div className="p-fluid formgrid grid">
              <JVInput required disabled={disableConsultant} placeholder="Consultant Name" column={3} control={control} name="name" error={errors.name?.message} />
              <JVInput required disabled placeholder="Email" column={3} control={control} name="email" error={errors.email?.message} />
              <JVInputMask required mask="(999) 999-9999" column={3} placeholder="Phone" control={control} name="homeNo" error={errors.homeNo?.message} />
              <JVInput required placeholder="Job Title" column={3} control={control} name="jobTitle" error={errors.jobTitle?.message} />

              <JVDropdown required column={3} control={control} name="visaId" error={errors.visaId?.message} options={visa} optionLabel="name" optionValue="id" placeholder="--Select Visa--" />
              <JVDropdown required column={3} control={control} name="visaReceivedBy" error={errors.visaReceivedBy?.message} options={Visa_Received_By} optionLabel="name" optionValue="value" placeholder="--Select Visa Received By--" />
              <div className="field col-12 md:col-4">
                <FileUpload chooseLabel={visaFile ? visaFile.name + " (" + (visaFile.size / 1024)?.toFixed(1) + " KB)" : "Upload Visa Copy"} style={{ height: "1rem" }} mode="basic" name="visa" auto customUpload uploadHandler={visaUploade} />
              </div>
              <JVDropdown required column={3} control={control} name="countryId" error={errors.countryId?.message} options={countries} optionLabel="name" optionValue="id" placeholder="Select Country" />
              <JVDropdownInput required column={3} completeMethod={completeMethodState} control={control} name="state" error={errors.state?.id?.message} options={states} optionLabel="name" placeholder="Search State" />
              <JVDropdownInput required column={3} completeMethod={completeMethodCity} control={control} name="city" error={errors.city?.id?.message} options={cities} optionLabel="name" placeholder="Search City" />
              <JVDropdown required column={3} control={control} name="experienceInMonth" error={errors.experienceInMonth?.message} options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

              <JVDropdown required column={3} control={control} name="noticePeriodInDays" error={errors.noticePeriodInDays?.message} options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />
              <JVInput required placeholder="Buying Rate" type={"number"} column={3} control={control} name="hourlyRate" error={errors.hourlyRate?.message} />
              <JVDropdown required column={3} control={control} name="tax_Term" error={errors.tax_Term?.message} options={Tax_Term} optionLabel="name" optionValue="id" placeholder="--Select TaxTerm--" />
              {!disablePaymentsTerm && <JVDropdown required column={3} disabled={disablePaymentsTerm} control={control} name="payment_Term" error={errors.payment_Term?.message} options={Payment_Term} optionLabel="name" optionValue="id" placeholder="--Select PaymentTerm--" />}
              <JVRadioBtn inline label="F2F Interview" required data={[{ label: "Yes", value: true }, { label: "No", value: false }]} column={3} control={control} name="faceToFaceInterview" error={errors.faceToFaceInterview?.message} />
            </div>
          </AccordionTab>
          {!disableEmployeeDetails && (
            <AccordionTab header="Employer Details:">
              <div className="p-fluid formgrid grid">
                <JVInput required disabled={disableEmployeeDetails} onBlur={fillSubVendor} placeholder="Employer Email" column={4} control={control} name="contactPersonEmail" error={errors.contactPersonEmail?.message} />
                <JVDropdownInput required disabled={disableEmployeeDetails} column={4} completeMethod={completeMethodClientCompanies}
                  control={control} name="vendorCompany" error={errors.vendorCompany?.id?.message} options={clientCompanies} optionLabel="name" placeholder="Search Employer Company" />
                <JVInput required disabled={disableEmployeeDetails} placeholder="Contact Name" column={4} control={control} name="contactPersonName" error={errors.contactPersonName?.message} />
                <JVInputMask required disabled={disableEmployeeDetails} mask="(999) 999-9999" column={4} placeholder="Employer Phone" control={control} name="contactPersonPhoneNo" error={errors.contactPersonPhoneNo?.message} />
              </div>
            </AccordionTab>
          )}
          <AccordionTab header="Education & Other Details:">
            <div className="p-fluid formgrid grid">
              <JVInput placeholder="Degree" column={3} control={control} name="degree" error={errors.degree?.message} />
              <JVInput placeholder="University" column={3} control={control} name="university" error={errors.university?.message} />
              <JVInput placeholder="Passing Year" type={"number"} column={3} control={control} name="passoutYear" error={errors.passoutYear?.message} />
              <JVDate column={3} placeholder="Date of Birth" control={control} name="dob" maxDate={new Date()} />
              <JVInput placeholder="SSN" column={3} type={"number"} control={control} name="ssn" error={errors.ssn?.message} />
              <JVInput placeholder="Linkedin" column={3} control={control} name="linkedin" error={errors.linkedin?.message} />
              <JVDropdown column={3} control={control} name="submissionType" error={errors.submissionType?.message} options={Submission_Type} optionLabel="name" optionValue="id" placeholder="--Select JobType--" />
              <JVInput placeholder="Salary" type={"number"} column={3} control={control} name="annualSalary" error={errors.annualSalary?.message} />
            </div>
          </AccordionTab>
          <AccordionTab header="Additional Info:">
            <div className="p-fluid formgrid grid">
              <div className="col-12 md:col-12 md:col-6">
                <JVSunEditor value={additionInfo} handleChange={setAdditionInfo} />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
        <div className="field col-12 md:col-12">
          <FileUpload chooseLabel={resumeFile ? resumeFile.name + " (" + (resumeFile.size / 1024)?.toFixed(1) + " KB)" : "Choose Resume"} mode="basic" name="resume" accept=".docx" auto customUpload uploadHandler={resumeUpload} />
        </div>
      </form>
    </Dialog>
  );
};

export default SubmissionForm;
